import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SubscriptionTabsEnum } from '../constants';

export const useSubscriptionRouter = () => {
  const navigate = useNavigate();
  return React.useMemo(
    () => ({
      goToCheckoutAddPlaidAccount: () =>
        navigate('/payment-methods/bank/select?integrationType=plaid&returnUrl=/subscription/checkout'),
      goToSubscriptionPlans: ({ returnUrl }: { returnUrl?: string }) =>
        navigate(`/subscription/${SubscriptionTabsEnum.Plans}`, { state: { returnUrl } }),
      goToSubscriptionCheckout: ({ returnUrl }: { returnUrl?: string }) =>
        navigate(`/subscription/${SubscriptionTabsEnum.Checkout}`, { state: { returnUrl } }),
    }),
    [navigate]
  );
};
